export const StartIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M4 1V15L14 8L4 1Z' fill='inherit' />
  </svg>
);
